module.exports = __webpack_public_path__ + "assets/img/sdwan-module6-1.07e8d7d5.jpg";